import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const enablePersonalizationTopButtonTariff: boolean = isFeature('personalization-top-button-tariff-enable');
export const personalizationTopButtonTariff: string =
    getFeature('personalization-top-button-tariff') || 'W1TB_1y_landing_segmentation_discount';
export const personalizationTopButtonTariffTouch: string =
    getFeature('personalization-top-button-tariff-touch') || 'W256GB_1y_landing_segmentation_discount';
